// extracted by mini-css-extract-plugin
module.exports = {"container":"Products_container__DY3Tm","header":"Products_header__YSH5g","cards":"Products_cards__I3CEO","carousel":"Products_carousel__LOKqw"};